import { BookingAvailabilitiesComponent } from "./booking-availabilities/booking-availabilities.component";
import { BookingAvailabilityDetailComponent } from "./booking-availability-detail/booking-availability-detail.component";
import { BookingDetailsComponent } from "./booking-details/booking-details.component";
import { BookingModalComponent } from "./booking-modal/booking-modal.component";
import { BookingSearchBarComponent } from "./booking-search-bar/booking-search-bar.component";
import { RowsDisplayComponent } from "./booking-search-bar/rows-display/rows-display.component";
import { BookingSeatsComponent } from "./booking-seats/booking-seats.component";
import { BookingStopsComponent } from "./booking-stops/booking-stops.component";

export {
  BookingAvailabilitiesComponent,
  BookingAvailabilityDetailComponent,
  BookingDetailsComponent,
  BookingModalComponent,
  BookingSearchBarComponent,
  RowsDisplayComponent,
  BookingSeatsComponent,
  BookingStopsComponent,
};

export const bookingComponents = [
  BookingAvailabilitiesComponent,
  BookingAvailabilityDetailComponent,
  BookingDetailsComponent,
  BookingModalComponent,
  BookingSearchBarComponent,
  RowsDisplayComponent,
  BookingStopsComponent,
]
